export default __webpack_public_path__ + "static/media/health.fec1e030.svg";